import AssessmentListComponent from "src/components/Assessment/AssessmentListHOC";

const CompletedAssessments = () => {

  return (
    <AssessmentListComponent status='completed' label='Completed' />
  )
}

export default CompletedAssessments;